import React from 'react'
import {ToolTipUI} from '../../widgets/components/UI/ToolTipUI'
import {useIntl} from 'react-intl'

const LabelWithTooltip = ({className, label, value, toolTipText}: any) => {
  const {formatMessage} = useIntl()
  return (
    <>
      <div className={className}>
        <div className='d-flex align-items-center mb-1'>
          <p className='text-muted font-size-13 m-0'>{formatMessage({id: label})}</p>
          <ToolTipUI tooltipText={toolTipText} />
        </div>
        <p className='font-size-13 m-0'>{value}</p>
      </div>      
    </>
  )
}

export default LabelWithTooltip
